module.exports = __webpack_public_path__ + "static/media/plan-list.d4428bca.svg";